import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addPatient = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    // '/api/method/technoerp.services.create_patient',
    '/api/resource/Patient',
    body
  );
  return data;
});
export const updatePatient = catchAsync(async (id, body) => {
  const { data } = await axiosInstance.put(
    // '/api/method/technoerp.services.update_patient',
    `/api/resource/Patient/${id}`,
    body
  );
  return data;
});
export const deletePatient = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Patient/${id}`
    // `/api/resource/Patient/${record}`
  );
  return data;
});

// export const getPatients = catchAsync(async () => {
//   const { data } = await axiosInstance.get(
//     `/api/method/technoerp.services.get_patients`
//   );
//   return data;
// });
export const getPatients = catchAsync(async (key = '', value = '') => {
  let baseUrl = `/api/resource/Patient?fields=["custom_file_number", "patient_name", "sex", "blood_group", "email", "mobile", "dob", "uid", "name", "custom_country"]&limit_start=0&limit_page_length=0&order_by=name desc`;
  if (value) {
    const filterBlusPhone =
      key === 'mobile'
        ? value?.startsWith('+')
          ? value?.substring(1)
          : value?.startsWith('966')
          ? value
          : `966${value}`
        : key === 'custom_file_number'
        ? value?.startsWith('P-')
          ? value
          : `P-${value}`
        : value;
    // console.log(filterBlusPhone,"filterBlusPhone",key,value);

    // console.log(filterBlusPhone,"filterBlusPhonefilterBlusPhone");

    if (key === 'uid') {
      baseUrl += `&filters=[["${key}","like","${value}%"]]`;
    } else {
      baseUrl += `&filters=[["${key}","like","%${filterBlusPhone}%"]]`;
    }
  }
  const { data } = await axiosInstance.get(
    baseUrl
    // `/api/method/technoerp.services.get_patients?page=${pageCount}&limit=10`
    // `/api/method/technoerp.services.get_patients?page=${pageCount}&limit=10&key=${key}&value=${value}`
  );
  return data;
});
export const getPatientDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    // `/api/method/technoerp.services.get_patient?patient=${id}`
    `/api/resource/Patient/${id}`
  );
  return data;
});
export const getCountries = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_countries'
  );
  return data;
});
export const getCountriesWithLanguages = catchAsync(async (currentLang) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_country?lang=${currentLang}`
  );
  return data;
});
// export const getCountriesWithLanguages = catchAsync(async (currentLang) => {
//   const { data } = await axiosInstance.get(
//     `/api/resource/countries`,
//     // `/api/resource/countries?fields=[%22name%22%2C%22${currentLang}%22]`,
//     {
//       params: { fields: ['name','ar'] },
//       paramsSerializer: {
//         indexes: null,
//       },
//     }
//   );
//   return data;
// });
export const getLanguages = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_languages'
  );
  return data;
});
